"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
function classNameForTextStyle(style) {
    return constants_1.BASE_CLASS_NAME + "--" + style;
}
exports.classNameForTextStyle = classNameForTextStyle;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/typography/lib/utils.js
// module id = ./node_modules/@react-mdc/typography/lib/utils.js
// module chunks = 1 2 3